import api from 'api';
import TypeItemGallery from 'records/TypeItemGallery';
import { DesignTemplates } from 'records/DesignTemplate';

export const TYPEITEM_GALLERIES_ASYNC_ACTION_START = 'TYPEITEM_GALLERIES_ASYNC_ACTION_START';
export const TYPEITEM_GALLERIES_ASYNC_ACTION_SUCCESS = 'TYPEITEM_GALLERIES_ASYNC_ACTION_SUCCESS';
export const TYPEITEM_GALLERIES_ASYNC_ACTION_ERROR = 'TYPEITEM_GALLERIES_ASYNC_ACTION_ERROR';
export const TYPEITEM_GALLERIES_RESET_STATE = 'TYPEITEM_GALLERIES_RESET_STATE';

function typeItemGalleriesAsyncActionStart() {
  return {
    type: TYPEITEM_GALLERIES_ASYNC_ACTION_START,
  };
}

function typeItemGalleriesAsyncActionError(error) {
  return {
    type: TYPEITEM_GALLERIES_ASYNC_ACTION_ERROR,
    error,
  };
}

function typeItemGalleriesAsyncActionSuccess(data) {
  return {
    type: TYPEITEM_GALLERIES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resettypeItemGalleriesState() {
  return {
    type: TYPEITEM_GALLERIES_RESET_STATE,
  };
}

export function gettypeItemGalleries(designTypeId, designSizeId, layoutId ) {
  return (dispatch, getState) => {
    dispatch(typeItemGalleriesAsyncActionStart());
    return api.request(
      `design/designtemplates/typeitem?designtid=${ designTypeId }&sizeid=${ designSizeId }&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(typeItemGalleriesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(typeItemGalleriesAsyncActionError('Unable to get main color list'));
      throw (err);
    });
  };
}

export function gettypeItemThemeGalleries(layoutId) {
  return (dispatch, getState) => {
    dispatch(typeItemGalleriesAsyncActionStart());
    return api.request(
      `design/designtemplates/typeitem?layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(typeItemGalleriesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(typeItemGalleriesAsyncActionError('Unable to get main color list'));
      throw (err);
    });
  };
}

export function getThemesCuisineBuzTypeAsync(designTypeId, designSizeId, foodTypeId, layoutId) {
  return (dispatch, getState) => {
    dispatch(typeItemGalleriesAsyncActionStart());
    return api.request(`design/designtemplates/typeitem?typeId=${ foodTypeId }&designtid=${ designTypeId }&sizeid=${ designSizeId }&layoutId=${layoutId!=undefined?layoutId:-1}`, 'get')
    .then((data) => {
      let typeItemGalleryData = getState().typeItemGalleries.get('data');
      let themeCuisineTypeData = TypeItemGallery.getTypeItemGalleryByTypeItemId(getState().typeItemGalleries.get('data'), foodTypeId).first().setIn(['designTemplates'], DesignTemplates(data));
      let replacedData = TypeItemGallery.setTypeItemGalleryByTypeItemId(typeItemGalleryData, foodTypeId, themeCuisineTypeData.get('designTemplates'));

      dispatch(typeItemGalleriesAsyncActionSuccess(replacedData));
      return themeCuisineTypeData;
    })
    .catch((err) => {
      dispatch(typeItemGalleriesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}

export function getThemesCuisineBuzSFlowAsync(foodTypeId, layoutId) {
  return (dispatch, getState) => {
    dispatch(typeItemGalleriesAsyncActionStart());
    return api.request(`design/designtemplates/typeitem?typeId=${ foodTypeId }&layoutId=${layoutId!=undefined?layoutId:-1}`, 'get')
    .then((data) => {
      let typeItemGalleryData = getState().typeItemGalleries.get('data');
      let themeCuisineTypeData = TypeItemGallery.getTypeItemGalleryByTypeItemId(getState().typeItemGalleries.get('data'), foodTypeId).first().setIn(['designTemplates'], DesignTemplates(data));
      let replacedData = TypeItemGallery.setTypeItemGalleryByTypeItemId(typeItemGalleryData, foodTypeId, themeCuisineTypeData.get('designTemplates'));

      dispatch(typeItemGalleriesAsyncActionSuccess(replacedData));
      return themeCuisineTypeData;
    })
    .catch((err) => {
      dispatch(typeItemGalleriesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}
